import {createActions} from 'client/framework';

const normalActions = ['TOGGLE_MODAL'];

export const confirmChangesModalActions = createActions(null, normalActions);
